// ASK-147 §14.21 — which fixture anchor a composed node belongs to. Pure: no THREE, no stage state
// (the caller passes `isRegistered`), so the rule is unit-tested in scripts/test-composed-attribution.mjs.

/** The anchor named by a `…__cat__<anchor>[__Body|__Lid]` node name, or null when the name has no `__cat__`. */
export function anchorFromCatName(name, isRegistered = () => false) {
	name = String(name || "");
	const i = name.indexOf("__cat__");
	if (i < 0) return null;
	const tail = name.slice(i + "__cat__".length);
	if (!tail) return null;
	if (isRegistered(tail)) return tail;
	const cut = tail.lastIndexOf("__");
	if (cut > 0) {
		const head = tail.slice(0, cut);
		if (isRegistered(head)) return head;
		if (/^(Body|Lid)$/.test(tail.slice(cut + 2))) return head;
	}
	return tail;
}

/** A composed node belongs to its NEAREST `__cat__`-named ancestor, itself included: one rule for a
 *  single-mesh Body (the mesh is `…__cat__<A>__Body`) and a grouped one (multi-primitive GLB: the Body is
 *  a Group, its child meshes carry generic names). Null when no ancestor is a catalogue clone. */
export function composedAnchorOf(node, isRegistered) {
	for (let n = node; n; n = n.parent) {
		const a = anchorFromCatName(n.name, isRegistered);
		if (a) return a;
	}
	return null;
}
